import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdvancedSearchComponent } from './advanced-search/components/advanced-search/advanced-search.component';
import { AuthGuard } from './auth/auth.guard';
import { LoginComponent } from './auth/login/login.component';
import { BulkBuildDataComponent } from './build-data/components/bulk-build-data/bulk-build-data.component';
import { ProdGamedataPushComponent } from './build-gamedata/prod-gamedata-push/prod-gamedata-push.component';
import { EntityHistoryComponent } from './common/components/entity-history/entity-history.component';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { SettingsComponent } from './entities/settings/settings.component';
import { FormCreatorComponent } from './form-creator/form-creator.component';
import { HomePageComponent } from './home-page/home-page.component';
import { ContentIssuesComponent } from './cms-v2/content-issues/content-issues.component';
import { ArtComponent } from './tools/art/art.component';
import { EconTableComponent } from './entities/econ-table/econ-table.component';
import { AssetVersionTableComponent } from './entities/asset-version-table/asset-version-table.component';
import { RenderPreviewToolComponent } from './tools/art/render-preview-tool/render-preview-tool.component';
import { BuildHistoryComponent } from './common/components/build-history/build-history.component';
import { AssetBundleTableAgGridComponent } from './cms-v2/entities/asset-bundle-table-ag-grid/asset-bundle-table-ag-grid.component';
import { FlashBackChallengeTableAgGridComponent } from './cms-v2/entities/challenge/components/flashback-challenge-table-ag-grid/challenge-table-ag-grid.component';
import { NufCollectionTableAgGridComponent } from './entities/nuf-collection/nuf-collection-table-ag-grid/nuf-collection-table-ag-grid.component';
import { BundleAssetViewComponent } from './entities/bundle-asset-view/bundle-asset-view.component';
// STORE
import { StoregamedataviewComponent } from './cms-v2/store/store-game-data/storegamedataview/storegamedataview.component';
// COLORS
import { BuildGamedataV3ViewComponent } from './build-gamedata/build-gamedata-v3-view/build-gamedata-v3-view.component';
import { ClientStringsTableAgGridComponent } from './cms-v2/entities/client-strings/components/client-strings/client-strings-ag-grid.component';
import { BuildGamedataV3Component } from './build-gamedata/build-gamedata-v3/build-gamedata-v3/build-gamedata-v3.component';
import { LocalizedStringsTableAgGridComponent } from './cms-v2/entities/localized-strings/components/localized-strings/localized-strings-ag-grid.component';
import { LocalizationTableComponent } from './localization/localization-table/localization-table.component';
import { LocalizationIndexComponent } from './localization/localization-index/localization-index.component';


// New routes scheme
import { routes as routesv2 } from './routes';
import { ReleaseProgressionLevelsV2Component } from './entities/release/release-progression-levels-v2/release-progression-levels-v2.component';
import { ReleaseNurtureCollectionComponent } from './entities/release/release-nurture-collection/release-nurture-collection/release-nurture-collection.component';
import { DynamicEntityFormComponentComponent } from './common/components/dynamic-form-v2/components/dynamic-entity-form-component/dynamic-entity-form-component.component';
import { DynamicEntityViewComponentComponent } from './common/components/dynamic-form-v2/components/dynamic-entity-view-component/dynamic-entity-view-component.component';
import { MetadataFormComponent } from './common/components/dynamic-form-v2/components/metadata-form/metadata-form.component';
import { ReleaseGardenPassComponent } from './entities/release/release-garden-pass/release-garden-pass/release-garden-pass.component';
import { SeasonalPrizesFormV2Component } from './cms-v2/entities/seasonal-prizes/seasonal-prizes-form-v2/seasonal-prizes-form-v2/seasonal-prizes-form-v2.component';
import { SeasonalPrizesViewV2Component } from './cms-v2/entities/seasonal-prizes/seasonal-prizes-view-v2/seasonal-prizes-view-v2/seasonal-prizes-view-v2.component';
import { SeasonalPrizesAgGridComponent } from './cms-v2/entities/seasonal-prizes/seasonal-prizes-ag-grid/seasonal-prizes-ag-grid/seasonal-prizes-ag-grid.component';
import { DiffToolViewComponent } from './entities/diff-tool-view/diff-tool-view.component';
import { DiffToolAgAgridComponent } from './entities/diff-tool-ag-agrid/diff-tool-ag-agrid.component';
import { SponsorViewV2Component } from './cms-v2/sponsor/sponsor-view-v2/sponsor-view-v2.component';
import { SponsorFormV2Component } from './cms-v2/sponsor/sponsor-form-v2/sponsor-form-v2.component';
import { SponsorTableAgGridComponent } from './cms-v2/sponsor/sponsor-table-ag-grid/sponsor-table-ag-grid.component';
import { LocalizationConfigFormComponent } from './cms-v2/entities/localization/form/localization-config-form-component/localization-config-form-component';
import { LocalizationConfigurationViewComponent } from './cms-v2/entities/localization/localization-config-view/localization-configuration-view/localization-configuration-view.component';
import { LocalizationConfigurationTableComponent } from './cms-v2/entities/localization/localization-config-view/localization-configuration-view/localization-configuration-table/localization-configuration-table/localization-configuration-table.component';
import { DynamicEntityHistoryComponent } from './common/components/dynamic-form-v2/components/dynamic-entity-history/dynamic-entity-history.component';
import { DynamicEntityTableComponent } from './common/components/dynamic-form-v2/components/dynamic-entity-table-component/dynamic-entity-table.component';
import { EntityTableComponent } from './common/components/dynamic-form-v2/components/entity-table-component/entity-table.component';
import { MetadataViewComponent } from './common/components/dynamic-view-v2/components/metadata-view/metadata-view.component';
import { DynamicListTableComponent } from './common/components/dynamic-list-table/dynamic-list-table.component';
import { RewardTrackTemplateAgGridComponent } from './cms-v2/entities/reward-track-templates/components/reward-track-template-ag-grid/reward-track-template-ag-grid.component';
import { ScheduleTypeFormV2Component } from './cms-v2/entities/schedule-type/components/schedule-form-v2/schedule-type-form-v2.component';
import { ScheduleTypeTableAgGridComponent } from './cms-v2/entities/schedule-type/components/schedule-type-table-ag-grid/schedule-type-table-ag-grid.component';
import { ScheduleTypeViewV2Component } from './cms-v2/entities/schedule-type/components/schedule-type-view-v2/schedule-type-view-v2.component';
import { QaUserGroupsAgGridComponent } from './cms-v2/entities/qa-user-groups/qa-user-groups-ag-grid/qa-user-groups-ag-grid.component';
import { QAUsersAgGridComponent } from './cms-v2/entities/qa-users/qa-users-ag-grid/qa-users-ag-grid.component';
import { QAUsersFormV3Component } from './cms-v2/entities/qa-users/qa-users-form-v3/qa-users-form-v3.component';
import { QAUserGroupsFormsV2Component } from './cms-v2/entities/qa-user-groups/qa-user-groups-forms-v2/qa-user-groups-forms-v2.component';
import { QAUserGroupsViewV2Component } from './cms-v2/entities/qa-user-groups/qa-user-groups-views-v2/qa-user-groups-views-v2.component';
import { QAUsersViewsV2Component } from './cms-v2/entities/qa-users/qa-users-views-v2/qa-users-views-v2.component';
import { RewardTrackTemplateFormV2Component } from './cms-v2/entities/reward-track-templates/components/reward-track-template-form-v2/reward-track-template-form-v2.component';
import { RewardTrackTemplateViewV2Component } from './cms-v2/entities/reward-track-templates/components/reward-track-template-view-v2/reward-track-template-view-v2.component';
import { GamedataDiffViewV2Component } from './cms-v2/entities/gamedata-diff-view-v2/gamedata-diff-view-v2.component';
import { GamedataCompareToolComponent } from './build-gamedata/gamedata-compare-tool/gamedata-compare-tool.component';
// Dynamic Mystery Box
import { DynamicMysteryBoxFormComponent } from './cms-v2/entities/dynamic-mystery-box/dynamic-mystery-box-form/dynamic-mystery-box-form.component';
import { DynamicMysteryBoxViewComponent } from './cms-v2/entities/dynamic-mystery-box/dynamic-mystery-box-view/dynamic-mystery-box-view.component';
import { DynamicMysteryBoxTableAgGridComponent } from './cms-v2/entities/dynamic-mystery-box/dynamic-mystery-box-table-ag-grid/dynamic-mystery-box-table-ag-grid.component';
// Mystery Box Content
import { MysteryBoxContentFormComponent } from './cms-v2/entities/mystery-box-content/mystery-box-content-form/mystery-box-content-form.component';
import { MysteryBoxContentViewComponent } from './cms-v2/entities/mystery-box-content/mystery-box-content-view/mystery-box-content-view.component';
import { MysteryBoxContentTableAgGridComponent } from './cms-v2/entities/mystery-box-content/mystery-box-content-table-ag-grid/mystery-box-content-table-ag-grid.component';
import { NotificationCenterComponent } from './notifications/notification-center.component';
import { ActivityTrackerComponent } from './activity-tracker/activity-tracker.component';
import { LANDING_ROUTE } from './common/constants/dashboard-visibility';
import { IdlePreloadingStrategy } from './routes/idle-preloading-strategy';


const routes: Routes = [
  { path: 'login', component: LoginComponent },
  // There was no `path: ''` route before this: `/` fell through to the `**` wildcard and rendered
  // the login screen even when signed in. AuthGuard on the landing route bounces anonymous users
  // back to /login, and the wildcard below still catches everything else. LANDING_ROUTE is /home
  // while the dashboard is hidden.
  { path: '', redirectTo: LANDING_ROUTE, pathMatch: 'full' },
  {
    path: 'home',
    component: HomePageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'form-creator',
    component: FormCreatorComponent,
  },
  {
    path: 'dynamic-form',
    component: DynamicFormComponent,
  },
  {
    path: 'flashback-challenges',
    component: FlashBackChallengeTableAgGridComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'build-history/:entityType/:id',
    component: BuildHistoryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'econ-table',
    component: EconTableComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'build-gamedata',
    component: BuildGamedataV3Component,
    canActivate: [AuthGuard],
    data: {
      permission: {
        abilities: ['read'],
        controller: 'GamedataController'
      }
    }
  },
  {
    path: 'gamedatalogs/:id',
    component: BuildGamedataV3ViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'gamedata-diff-v2',
    component: GamedataDiffViewV2Component,
    canActivate: [AuthGuard],
    data: {
      permission: {
        abilities: ['read'],
        controller: 'GamedataController'
      }
    }
  },
  {
    path: 'gamedata/compare',
    component: GamedataCompareToolComponent,
    canActivate: [AuthGuard],
    data: {
      permission: {
        abilities: ['read'],
        controller: 'GamedataController'
      }
    }
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'settings/:type',
    component: SettingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'art-tools',
    component: ArtComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'render-preview-tool',
    component: RenderPreviewToolComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'asset-bundles',
    component: AssetBundleTableAgGridComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'bundle-view',
    component: BundleAssetViewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'history/:entityType/:id',
    component: EntityHistoryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'prod-gamedata',
    component: ProdGamedataPushComponent,
    canActivate: [AuthGuard],
    data: {
      permission: {
        abilities: ['prod_push'],
        controller: 'GamedataController'
      }
    }
  },
  {
    path: 'advanced-search',
    component: AdvancedSearchComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'bulk-build-search',
    component: BulkBuildDataComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'store-game-data',
    component: StoregamedataviewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'asset-versions/:table/:type/:id',
    component: AssetVersionTableComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'nuf-collection',
    component: NufCollectionTableAgGridComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'localization-strings',
    component: LocalizedStringsTableAgGridComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'client-strings',
    component: ClientStringsTableAgGridComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'localization',
    component: LocalizationIndexComponent,
    canActivate: [AuthGuard],
    pathMatch: 'full',
  },
  {
    path: 'localization/:tableName',
    component: LocalizationTableComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'localization-configuration',
    component: LocalizationConfigurationTableComponent, 
    canActivate: [AuthGuard],
  },
  {
    path: 'localization-configuration/add',
    component: LocalizationConfigFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'localization-configuration/:id',
    component: LocalizationConfigurationViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'localization-configuration/edit/:id',
    component: LocalizationConfigFormComponent,
    canActivate: [AuthGuard],
  },
  // SPONSORTS
  {
    path: 'sponsors',
    component: SponsorTableAgGridComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'sponsors/add',
    component: SponsorFormV2Component,
    canActivate: [AuthGuard],
  },
  {
    path: 'sponsors/:id',
    component: SponsorViewV2Component,
    canActivate: [AuthGuard],
  },
  {
    path: 'sponsors/edit/:id',
    component: SponsorFormV2Component,
    canActivate: [AuthGuard],
  },
  // Dynamic Mystery Box
  {
    path: 'dynamic-mystery-box',
    component: DynamicMysteryBoxTableAgGridComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dynamic-mystery-box/add',
    component: DynamicMysteryBoxFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dynamic-mystery-box/:id',
    component: DynamicMysteryBoxViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dynamic-mystery-box/edit/:id',
    component: DynamicMysteryBoxFormComponent,
    canActivate: [AuthGuard],
  },
  // Mystery Box Content
  {
    path: 'mystery-box-content',
    component: MysteryBoxContentTableAgGridComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mystery-box-content/add',
    component: MysteryBoxContentFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mystery-box-content/:id',
    component: MysteryBoxContentViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mystery-box-content/edit/:id',
    component: MysteryBoxContentFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'diff-jobs',
    component: DiffToolAgAgridComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'diff-jobs/:id',
    component: DiffToolViewComponent,
    canActivate: [AuthGuard],
  },
   // Dynamic List Tables
   {
    path: 'link-destination',
    component: DynamicListTableComponent,
    canActivate: [AuthGuard],
   },

   {
    path: 'scene-types/:id',
    redirectTo: 'scene-types',
   },
   {
    path: 'scene-types',
    component: DynamicListTableComponent,
    canActivate: [AuthGuard],
   },

   {
    path: 'entity-type-settings',
    component: DynamicListTableComponent,
    canActivate: [AuthGuard],
   },
   {
    path: 'ImagerySettings',
    component: DynamicListTableComponent,
    canActivate: [AuthGuard],
   },
   {
    path: 'content-hold',
    component: DynamicListTableComponent,
    canActivate: [AuthGuard],
   },
   {
    path: 'challenge-content-hold',
    component: DynamicListTableComponent,
    canActivate: [AuthGuard],
   },
   {
    path: 'qa-user-groups',
    component: QaUserGroupsAgGridComponent,
    canActivate: [AuthGuard],
   },
   {
    path: 'qa-user-groups/add',
    component: QAUserGroupsFormsV2Component,
    canActivate: [AuthGuard],
   },
   {
    path: 'qa-user-groups/:id',
    component: QAUserGroupsViewV2Component,
    canActivate: [AuthGuard],
   },
   {
    path: 'qa-user-groups/edit/:id',
    component: QAUserGroupsFormsV2Component,
    canActivate: [AuthGuard],
   },
   {
    path: 'qa-users',
    component: QAUsersAgGridComponent,
    canActivate: [AuthGuard],
   },
   {
    path: 'qa-users/add',
    component: QAUsersFormV3Component,
    canActivate: [AuthGuard],
   },
   {
    path: 'qa-users/:id',
    component: QAUsersViewsV2Component,
    canActivate: [AuthGuard],
   },
   {
    path: 'qa-users/edit/:id',
    component: QAUsersFormV3Component,
    canActivate: [AuthGuard],
   },
   {
    path: 'schedule-types',
    component: ScheduleTypeTableAgGridComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'schedule-types/add',
    component: ScheduleTypeFormV2Component,
    canActivate: [AuthGuard],
  },
  {
    path: 'schedule-types/:id',
    component: ScheduleTypeViewV2Component,
    canActivate: [AuthGuard],
  },
  {
    path: 'schedule-types/edit/:id',
    component: ScheduleTypeFormV2Component,
    canActivate: [AuthGuard],
  },
   // Dynamic Entities
  {
    path: 'dynamic-entities',
    component: EntityTableComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dynamic-entities/view/:id',
    component: MetadataViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dynamic-entities/add',
    component: MetadataFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dynamic-entities/edit/:id',
    component: MetadataFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'd/:entityName',
    component: DynamicEntityTableComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'd/:entityName/edit/:id',
    component: DynamicEntityFormComponentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'd/:entityName/add',
    component: DynamicEntityFormComponentComponent,
    canActivate: [AuthGuard],
  },
  { 
    path: 'd/:entityName/view/:id', 
    component: DynamicEntityViewComponentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'd/history/:entityType/:id',
    component: DynamicEntityHistoryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'rewards-track-templates',
    component: RewardTrackTemplateAgGridComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'rewards-track-templates/add',
    component: RewardTrackTemplateFormV2Component,
    canActivate: [AuthGuard],
  },
  {
    path: 'rewards-track-templates/edit/:id',
    component: RewardTrackTemplateFormV2Component,
    canActivate: [AuthGuard],
  },
  {
    path: 'rewards-track-templates/:id',
    component: RewardTrackTemplateViewV2Component,
    canActivate: [AuthGuard],
  },
  {
    path: 'content-issues',
    component: ContentIssuesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'notifications',
    component: NotificationCenterComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'activity-tracker',
    component: ActivityTrackerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    component: HomePageComponent,
    // canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot([
    ...routesv2,
    ...routes
  ], {
    // Lazy entity features are fetched in the background once the app is idle.
    preloadingStrategy: IdlePreloadingStrategy,
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
